import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'

import {
  MainCustomerQuery,
  MainCustomerQueryVariables,
} from '../../../generated/graphql'
import { MainCustomer as QUERY } from '../../../graphql/Query/Customer.graphql'
import { ClientBehaviours } from '../../utils'

export interface Customer {
  firstName: string
  email: string
  hashedEmail?: string | null
  wishlist: {
    itemCount: number
    skus: number[]
    __typename: 'Wishlist'
  }
  emailMarketingPreference: boolean
  smsMarketingPreference: boolean
  loyalty?: {
    pointsToNextTier?: number | null
    __typename: 'Loyalty'
  }
  __typename: 'Customer'
}

export const Customer = (
  client: ApolloClient<NormalizedCacheObject>,
  { behaviours }: { behaviours: ClientBehaviours },
) => async (_, args: MainCustomerQueryVariables): Promise<Customer | null> => {
  if (behaviours.override) {
    return {
      firstName: 'Neil Armstrong',
      email: 'neil.armstrong@themoon.com',
      hashedEmail: '',
      wishlist: {
        itemCount: 0,
        skus: [],
        __typename: 'Wishlist',
      },
      loyalty: {
        pointsToNextTier: null,
        __typename: 'Loyalty',
      },
      emailMarketingPreference: false,
      smsMarketingPreference: false,
      __typename: 'Customer',
    }
  }

  const { data } = await client.query<
    MainCustomerQuery,
    MainCustomerQueryVariables
  >({
    query: QUERY,
    variables: args,
  })

  if (!data.customer) {
    return null
  }

  return {
    firstName: data.customer.fullName.split(' ')[0],
    email: data.customer.email,
    hashedEmail: data.customer.hashedEmail,
    wishlist: {
      itemCount: data.customer.wishlist?.total || 0,
      skus: (data.customer.wishlist?.items || []).map(
        (item) => item.selectedVariant?.sku || item.product?.sku,
      ),
      __typename: 'Wishlist',
    },
    emailMarketingPreference: data.customer.emailMarketingPreference || false,
    smsMarketingPreference: data.customer.smsMarketingPreference || false,
    loyalty: {
      pointsToNextTier:
        data.customer.loyaltyAccountDashboard?.summary?.pointsToNextTier ||
        null,
      __typename: 'Loyalty',
    },
    __typename: 'Customer',
  }
}
